import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { ResultsLabel, TotalResults } from './styled';

const mapStateToProps = ({ api: { total } }) => ({ total });

const style = isDesktop =>
  isDesktop
    ? {
      marginTop: '5px',
      textAlign: 'right'
    }
    : { marginRight: '8px' };

const SearchResults = ({ isDesktop, total }) => (
  <div style={style(isDesktop)}>
    <TotalResults data-cy="total-count" isDesktop={isDesktop}>
      {total}
    </TotalResults>
    <ResultsLabel> {total === 1 ? 'result' : 'results'}</ResultsLabel>
  </div>
);

SearchResults.propTypes = {
  isDesktop: PropTypes.bool,
  total: PropTypes.number
};

export default connect(mapStateToProps)(SearchResults);
